// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { version } from './version';

export const environment = {
  production: false,
  appVersionAddon: '-staging',
  webappName: 'Straatbeeld Online Meldformulier (staging)',
  api_endpoint: 'https://api.sd-staging.nl/',
  sentry: {
    dsn: 'https://69e4cab4867dbff48feccc952e83bfd7@o4507735602298880.ingest.de.sentry.io/4508734002430032',
    environment: 'staging',
    version: version + '-staging',
  }
};
